export const globalQueryKeys = {
  files: ['files'],
  devices: ['devices'],
  incidents: ['incidents'],
  licenses: ['licenses'],
  warranties: ['warranties'],
};
